import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopimprichichwadcab() {



  const cardData = {


  keyword: "Mumbai to Pimpri Chinchwad Cab",

  headingDescription: "Trustline Cab provides reliable Mumbai to Pimpri Chinchwad cab services with safe, comfortable, and affordable transportation for business travel, industrial visits, corporate meetings, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickups, smooth highway travel, and a hassle-free journey from Mumbai to Pimpri Chinchwad. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to meet every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained cars, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Mumbai to Pimpri Chinchwad taxi services.",

  topPlaces: [
    {
      title: "Pimpri MIDC",
      description: "Pimpri MIDC is one of Pune's major industrial zones, home to automobile companies, manufacturing units, engineering firms, and large corporate establishments. It is an important destination for industrial professionals and business travelers."
    },
    {
      title: "Bhosari MIDC",
      description: "Bhosari MIDC is a prominent industrial area known for engineering companies, automotive businesses, manufacturing plants, warehouses, and commercial units. It attracts regular corporate and industrial visitors from Mumbai."
    },
    {
      title: "Chinchwad",
      description: "Chinchwad is a developed commercial and residential locality featuring business centers, shopping areas, educational institutions, automobile companies, and excellent connectivity. It is a key destination within Pimpri Chinchwad."
    },
    {
      title: "Akurdi",
      description: "Akurdi is an important educational and commercial hub in Pimpri Chinchwad, known for engineering institutes, corporate offices, residential developments, and easy access to nearby industrial areas."
    },
    {
      title: "Talawade IT Park",
      description: "Talawade IT Park is an emerging technology destination featuring IT companies, software firms, business centers, and corporate offices. It is a preferred location for professionals and technology businesses."
    },
    {
      title: "Hinjewadi",
      description: "Hinjewadi is Pune's largest IT and corporate hub, featuring multinational companies, technology parks, startups, and modern office campuses. It attracts thousands of professionals and business visitors."
    },
    {
      title: "Dagdusheth Halwai Ganpati Temple",
      description: "Dagdusheth Halwai Ganpati Temple is one of Pune's most famous cultural landmarks, attracting devotees and tourists with its rich heritage, grand celebrations, and spiritual importance."
    },
    {
      title: "Aga Khan Palace",
      description: "Aga Khan Palace is a historic Pune monument known for its beautiful architecture and connection with India's freedom movement. It is a popular destination for tourists and history enthusiasts."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station located between Mumbai and Pune, famous for waterfalls, viewpoints, caves, and lush green landscapes. It is a popular getaway destination for families and travelers."
    },
    {
      title: "Karla Caves",
      description: "Karla Caves are ancient Buddhist rock-cut caves near Lonavala featuring historic carvings, impressive architecture, and cultural significance. They are a popular sightseeing attraction on the Mumbai-Pune route."
    }
  ],






"services": [
  {
    "name": "Mumbai to Pimpri Chinchwad Cab",
    "description": "Book Mumbai to Pimpri Chinchwad Cab for comfortable intercity travel with professional chauffeurs, clean AC vehicles, transparent pricing, and doorstep pickup. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium cars for business trips, family travel, airport transfers, and outstation journeys."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Taxi",
    "description": "Choose Mumbai to Pimpri Chinchwad Taxi for safe and reliable travel with experienced drivers, affordable fares, premium vehicles, comfortable seating, and smooth highway connectivity."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Cab Service",
    "description": "Our Mumbai to Pimpri Chinchwad Cab Service offers one-way and round-trip transportation with punctual pickup, AC vehicles, professional chauffeurs, transparent fares, and reliable customer support."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Taxi Service",
    "description": "Book Mumbai to Pimpri Chinchwad Taxi Service with clean vehicles, trained drivers, affordable pricing, flexible booking options, and comfortable travel for personal and corporate journeys."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Cab Booking",
    "description": "Complete Mumbai to Pimpri Chinchwad Cab Booking online with instant confirmation, multiple vehicle choices, fixed pricing, doorstep pickup, and hassle-free intercity travel."
  },
  {
    "name": "Cab from Mumbai to Pimpri Chinchwad",
    "description": "Hire Cab from Mumbai to Pimpri Chinchwad with professional chauffeurs, spacious luggage capacity, AC comfort, and reliable transportation for long-distance journeys."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Car Rental",
    "description": "Choose Mumbai to Pimpri Chinchwad Car Rental with Sedan, Ertiga, Innova Crysta, SUV, and premium cars for family trips, corporate travel, and private transportation."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad One Way Cab",
    "description": "Book Mumbai to Pimpri Chinchwad One Way Cab for direct destination travel with affordable fares, no return charges, comfortable vehicles, and experienced drivers."
  },
  {
    "name": "Cheap Mumbai to Pimpri Chinchwad Cab",
    "description": "Select Cheap Mumbai to Pimpri Chinchwad Cab with budget-friendly rates, clean AC vehicles, professional chauffeurs, and dependable service."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Taxi Fare",
    "description": "Check Mumbai to Pimpri Chinchwad Taxi Fare with transparent pricing, fixed charges, and multiple vehicle options including Sedan, Ertiga, and Innova Crysta."
  },
  {
    "name": "Book Mumbai to Pimpri Chinchwad Cab Online",
    "description": "Book Mumbai to Pimpri Chinchwad Cab Online with quick confirmation, easy reservation, flexible timings, and trusted chauffeur-driven transportation."
  },
  {
    "name": "Mumbai Airport to Pimpri Chinchwad Cab",
    "description": "Reserve Mumbai Airport to Pimpri Chinchwad Cab for airport transfers with punctual pickup, comfortable AC cars, luggage support, and reliable chauffeur service."
  },
  {
    "name": "Mumbai Airport to Pimpri Chinchwad Taxi",
    "description": "Travel from Mumbai Airport to Pimpri Chinchwad Taxi service with professional drivers, premium vehicles, affordable fares, and safe highway travel."
  },
  {
    "name": "Mumbai to Pimpri Akurdi Cab",
    "description": "Book Mumbai to Pimpri Akurdi Cab for convenient travel with clean vehicles, experienced drivers, affordable pricing, and doorstep pickup service."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad One Way Taxi",
    "description": "Choose Mumbai to Pimpri Chinchwad One Way Taxi for comfortable single-side travel with fixed fares, premium cars, and professional chauffeurs."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Innova Cab",
    "description": "Travel with Mumbai to Pimpri Chinchwad Innova Cab featuring spacious seating, AC comfort, premium interiors, luggage space, and experienced drivers."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Ertiga Cab",
    "description": "Book Mumbai to Pimpri Chinchwad Ertiga Cab for family and group travel with affordable rates, comfortable seating, and reliable chauffeur-driven service."
  },
  {
    "name": "Dadar to Pimpri Chinchwad Cab",
    "description": "Choose Dadar to Pimpri Chinchwad Cab for smooth intercity travel with professional drivers, clean cars, transparent pricing, and flexible booking."
  },
  {
    "name": "Andheri to Pimpri Chinchwad Cab",
    "description": "Book Andheri to Pimpri Chinchwad Cab with premium vehicles, experienced chauffeurs, affordable fares, and convenient pickup options."
  },
  {
    "name": "Mumbai to Baner Cab",
    "description": "Reserve Mumbai to Baner Cab for corporate and personal travel with comfortable AC vehicles, professional drivers, and reliable service."
  },
  {
    "name": "Mumbai to Wakad Cab",
    "description": "Choose Mumbai to Wakad Cab for safe travel with premium cars, experienced chauffeurs, affordable fares, and doorstep pickup."
  },
  {
    "name": "Mumbai to Akurdi Cab",
    "description": "Book Mumbai to Akurdi Cab for convenient transportation with clean vehicles, professional drivers, and flexible travel schedules."
  },
  {
    "name": "Mumbai to Pune Cab Booking",
    "description": "Complete Mumbai to Pune Cab Booking with multiple vehicle options, instant confirmation, affordable pricing, and comfortable travel."
  },
  {
    "name": "Taxi Services in Mumbai Central Station",
    "description": "Get Taxi Services in Mumbai Central Station for local and outstation journeys with reliable cars, professional chauffeurs, and 24x7 support."
  },
  {
    "name": "Best Cabs in Pune",
    "description": "Choose Best Cabs in Pune for premium travel solutions with comfortable vehicles, trained drivers, affordable rates, and dependable service."
  }
],

"tableData": [
  ["Mumbai to Pimpri Chinchwad Cab", "Mumbai to Pimpri Chinchwad Taxi"],
  ["Mumbai to Pimpri Chinchwad Cab Service", "Mumbai to Pimpri Chinchwad Taxi Service"],
  ["Mumbai to Pimpri Chinchwad Cab Booking", "Cab from Mumbai to Pimpri Chinchwad"],
  ["Mumbai to Pimpri Chinchwad Car Rental", "Mumbai to Pimpri Chinchwad One Way Cab"],
  ["Cheap Mumbai to Pimpri Chinchwad Cab", "Mumbai to Pimpri Chinchwad Taxi Fare"],
  ["Book Mumbai to Pimpri Chinchwad Cab Online", "Mumbai Airport to Pimpri Chinchwad Cab"],
  ["Mumbai Airport to Pimpri Chinchwad Taxi", "Mumbai to Pimpri Akurdi Cab"],
  ["Mumbai to Pimpri Chinchwad One Way Taxi", "Mumbai to Pimpri Chinchwad Innova Cab"],
  ["Mumbai to Pimpri Chinchwad Ertiga Cab", "Dadar to Pimpri Chinchwad Cab"],
  ["Andheri to Pimpri Chinchwad Cab", "Mumbai to Baner Cab"],
  ["Mumbai to Wakad Cab", "Mumbai to Akurdi Cab"],
  ["Mumbai to Pune Cab Booking", "Taxi Services in Mumbai Central Station"],
  ["Best Cabs in Pune", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Pimpri Chinchwad Cab Service",
    WhyChoosedescription: "Trustline Cab provides comfortable Mumbai to Pimpri Chinchwad cab services with professional drivers, quality vehicles, and smooth intercity travel solutions."
  },
  {
    WhyChooseheading: "Direct Pickup & Drop Facility",
    WhyChoosedescription: "Enjoy convenient doorstep pickup from any location in Mumbai and direct drop at Pimpri Chinchwad areas including residential, office, and industrial locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for Expressway Route",
    WhyChoosedescription: "Our skilled chauffeurs have excellent knowledge of the Mumbai-Pune Expressway and ensure safe, timely, and comfortable travel."
  },
  {
    WhyChooseheading: "Comfortable Fleet for Every Passenger",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your group size and travel requirements."
  },
  {
    WhyChooseheading: "Affordable Mumbai to Pimpri Chinchwad Fare",
    WhyChoosedescription: "Get transparent pricing with competitive cab fares and complete fare details before booking without unexpected charges."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose one-way cabs, return journeys, or customized travel packages based on your schedule and destination requirements."
  },
  {
    WhyChooseheading: "Perfect for Corporate & Personal Travel",
    WhyChoosedescription: "Our Mumbai to Pimpri Chinchwad cabs are ideal for business meetings, employee travel, family trips, airport transfers, and personal journeys."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Support",
    WhyChoosedescription: "Book your Mumbai to Pimpri Chinchwad cab anytime with quick assistance, instant confirmation, and reliable customer support."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Mumbai to Pimpri Chinchwad cab service?",
    answer: "Yes, Trustline Cab offers reliable Mumbai to Pimpri Chinchwad cab services for one-way travel, round trips, corporate transportation, and personal journeys."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Pimpri Chinchwad?",
    answer: "Yes, affordable one-way cab services are available with flexible pickup and direct drop options."
  },
  {
    question: "Do you provide pickup from Mumbai Airport to Pimpri Chinchwad?",
    answer: "Yes, we offer direct airport transfer cabs from Mumbai Airport Terminal 1 and Terminal 2 to Pimpri Chinchwad."
  },
  {
    question: "Which vehicles are available for Mumbai to Pimpri Chinchwad travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable travel."
  },
  {
    question: "Is Mumbai to Pimpri Chinchwad cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7 for convenient travel according to your preferred timing."
  },
  {
    question: "Can I book a return cab from Pimpri Chinchwad to Mumbai?",
    answer: "Yes, round-trip cab options are available for customers requiring return travel between Pimpri Chinchwad and Mumbai."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed booking quotation."
  },
  {
    question: "Can I reserve my Mumbai to Pimpri Chinchwad cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and preferred pickup time."
  },
  {
    question: "Is this cab service suitable for corporate travel?",
    answer: "Yes, our Mumbai to Pimpri Chinchwad cab service is suitable for corporate employees, business visits, and industrial area travel."
  },
  {
    question: "How can I book Mumbai to Pimpri Chinchwad Cab with Trustline Travels?",
    answer: "Share your pickup location, Pimpri Chinchwad destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Patil",
    feedback: "Trustline Travels provided excellent Mumbai to Pimpri Chinchwad cab service with timely pickup, a comfortable vehicle, and a professional driver. The entire journey was smooth and reliable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback: "The travel experience was very convenient with easy booking, clean interiors, and excellent driver support. Trustline Travels made our Mumbai to Pimpri Chinchwad trip comfortable and stress-free.",
    rating: 5
  }
];





  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pimpri Chinchwad Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/mumbai-to-pimpri-chinchwad-cab.webp",
  "description": "Book Mumbai to Pimpri Chinchwad cab service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, airport, and outstation taxi services from Mumbai to Pimpri Chinchwad with Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8264"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/mumbai-to-pimpri-chinchwad-cab"
  }
};








  return (
    <div>
<Helmet>
  <title>Mumbai to Pimpri Chinchwad Cab | One Way Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Mumbai to Pimpri Chinchwad cab service with Trustline Travels for reliable and affordable travel. Get one-way, round-trip, airport, and private taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="mumbai to pimpri chinchwad cab, mumbai to pimpri akurdi cab, mumbai airport to pimpri chinchwad, mumbai to pimpri chinchwad one way cab, mumbai to pimpri chinchwad taxi fare, dadar to pimpri chinchwad cab, andheri to pimpri chinchwad cab, Mumbai to Pimpri Chinchwad Taxi, Mumbai PCMC Cab Service, Mumbai to Pimpri Chinchwad One Way Cab, Mumbai Airport to PCMC Taxi, Mumbai Pimpri Chinchwad Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/100.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopimprichichwadcab;